import * as firebase from "firebase";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDaeu9mbyaZEUAiMUWIEiSu5cStW--Ga8g",
  authDomain: "flyby-nyc20.firebaseapp.com",
  databaseURL: "https://flyby-nyc20.firebaseio.com",
  projectId: "flyby-nyc20",
  storageBucket: "flyby-nyc20.appspot.com",
  messagingSenderId: "479082390845",
  appId: "1:479082390845:web:6a04b019caa0b06bd11154",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

//MARK: - functions

export function GetRestaurant(restaurantID) {
  return Promise.all([
    getRestaurantInfo(restaurantID),
    getRestaurantMenu(restaurantID),
  ])
    .then(([info, menuArray]) => {
      if (info.stripeID && info.stripeID && menuArray) {
        return {
          name: info.name,
          stripeID: info.stripeID,
          menuArray: menuArray,
        };
      } else {
        return Promise.reject();
      }
    })
    .catch((error) => {
      return;
    });
}

function getRestaurantInfo(restaurantID) {
  const restaurantRef = db.collection("Restaurants").doc(restaurantID);
  return restaurantRef.get().then(function (doc) {
    const name = doc.data()["name"];
    const stripeID = doc.data()["stripeID"];
    // const screenTitle = name + " - " + "Table " + tableID + " - " + stripeID;
    // return screenTitle;
    return { name: name, stripeID: stripeID };
  });
  // .then((title) => this.props.navigation.setOptions({ title: title }));
}

function getRestaurantMenu(restaurantID) {
  const docRef = db
    .collection("Restaurants")
    .doc(restaurantID)
    .collection("Menu");
  return docRef
    .get()
    .then(function (snap) {
      const itemArray = [];
      const catArray = [];
      var menu = {};

      snap.forEach(function (doc) {
        if (doc.data()["typeOf"] === "item" && doc.data()) {
          //console.log("Document data:", doc.data())

          const item = {};
          itemArray.push({
            itemID: doc.id,
            title: doc.data()["title"],
            description: doc.data()["description"],
            price: doc.data()["price"],
            categoryID: doc.data()["categoryID"],
          });
        }
        if (doc.data()["typeOf"] === "category") {
          //console.log("Document data:", doc.data());
          catArray.push({
            title: doc.data()["title"],
            categoryID: doc.id,
            itemListOrder: doc.data()["itemListOrder"],
          });
        }
        if (doc.data()["menu"] === "category") {
          //console.log("Document data:", doc.data());
          catArray.push({
            title: doc.data()["title"],
            categoryID: doc.id,
            itemListOrder: doc.data()["itemListOrder"],
          });
        }
        if (doc.id === "Menu") {
          //console.log("Document data:", doc.data());
          menu = doc.data();
        }
      });
      return [menu, itemArray, catArray];
      // console.log("Document data:", doc.data());
    })
    .then(function (results) {
      const menu = results[0];
      const itemArray = results[1];
      const catArray = results[2];

      console.log("bono");
      console.log(itemArray);
      console.log(catArray);
      //console.log(this.state.finalMenu)
      const menuArray = [];
      for (let catID of menu.categoryListOrder) {
        // this.setState({finalMenu.cat: i};

        const cat = catArray.find((element) => element.categoryID === catID);

        var iArray = [];
        for (let itemID of cat.itemListOrder) {
          const item = itemArray.find((element) => element.itemID === itemID);
          if (item !== undefined) {
            iArray.push(item);
          }
        }
        menuArray.push({
          title: cat.title,
          data: iArray,
        });
      }

      return menuArray;
    });
}
